import React, { useEffect } from "react"

import { useAccount } from "@shared/contexts"

import { WOW_MONEY_POPUP_CLOSE_DELAY } from "live/constants"
import { useWowMoneyContext } from "live/contexts"

import Accumulate from "./Accumulate"
import Anonymous from "./Anonymous"
import Complete from "./Complete"
import Enter from "./Enter"

const WowMoney = () => {
  const {
    account: { viewer },
  } = useAccount()
  const {
    cycleStartedAt,
    isAccrualTarget,
    popupType: type,
    setPopupType: setType,
  } = useWowMoneyContext()

  const role = viewer?.role

  const renderContent = () => {
    switch (type) {
      case "ANONYMOUS":
        return <Anonymous />
      case "ENTER":
        // 주기 시작 시각을 모르는 동안 렌더하면 dayjs 가 undefined 를
        // 현재 시각으로 바꿔버려 엉뚱한 입장 시각이 잠깐 노출된다
        return cycleStartedAt ? <Enter enteredAt={cycleStartedAt} /> : null
      case "ACCUMULATE":
        return <Accumulate />
      case "COMPLETE":
        return <Complete />
      default:
        return null
    }
  }

  useEffect(() => {
    if (!role) return

    setType(role === "ANONYMOUS" ? "ANONYMOUS" : "ENTER")
  }, [role, setType])

  useEffect(() => {
    if (!type) return

    setTimeout(() => {
      setType(undefined)
    }, WOW_MONEY_POPUP_CLOSE_DELAY)
  }, [type, setType])

  const content = renderContent()

  // content 가 없으면 닫기 버튼만 있는 빈 팝업이 뜨므로 껍데기째 그리지 않는다
  if (!content || !isAccrualTarget) return null

  return (
    <div className="wowcoinWrap">
      <div className="coinPop">
        {content}
        <button
          type="button"
          className="btnCoinClose"
          onClick={() => {
            setType(undefined)
          }}
        >
          <span>닫기</span>
        </button>
      </div>
    </div>
  )
}

export default WowMoney
